"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringReverse = void 0;
/**
 * Odwraca ciąg znaków
 *
 * @export
 * @param {string} text
 * @returns {string}
 */
function stringReverse(text) {
    return text.split('').reverse().join('');
}
exports.stringReverse = stringReverse;
//# sourceMappingURL=stringReverse.js.map